(function () {
    'use strict';

    if (!document.querySelector('meta[name="csrf-token"]')) return;

    var INACTIVITY_TIMEOUT = 10 * 60 * 1000;
    var WARNING_BEFORE = 60 * 1000;
    var LAST_ACTIVITY_KEY = 'session_last_activity';

    var idleTimer, warningTimer, warningShown = false;

    function getLastActivity() {
        try {
            return parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || '0', 10);
        } catch (e) {
            return 0;
        }
    }

    function setLastActivity() {
        try {
            localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
        } catch (e) {}
    }

    function forceLogout() {
        clearTimeout(idleTimer);
        clearTimeout(warningTimer);

        var form = document.createElement('form');
        form.method = 'POST';
        form.action = '/logout';
        var token = document.createElement('input');
        token.type = 'hidden';
        token.name = '_token';
        token.value = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        form.appendChild(token);
        document.body.appendChild(form);
        form.submit();
    }

    function showWarning() {
        if (warningShown) return;
        warningShown = true;

        var secondsLeft = 60;
        var countdownInterval;

        var dialog = bootbox.dialog({
            title: '<i class="bi bi-clock me-2"></i>Session Timeout',
            message: '<p class="text-center mb-4">Your session will expire due to inactivity.</p>' +
                     '<div class="text-center mb-3">' +
                       '<span id="session-countdown" class="display-5 fw-bold text-primary">60</span>' +
                       '<span class="d-block text-muted mt-1">seconds remaining</span>' +
                     '</div>',
            closeButton: false,
            centerVertical: true,
            size: 'small',
            buttons: {
                extend: {
                    label: "I'm Still Here",
                    className: 'btn-primary',
                    callback: function () {
                        clearInterval(countdownInterval);
                        warningShown = false;
                        setLastActivity();
                        startTimers(INACTIVITY_TIMEOUT);
                    }
                }
            }
        });

        countdownInterval = setInterval(function () {
            secondsLeft--;
            var el = document.getElementById('session-countdown');
            if (el) el.textContent = secondsLeft;

            if (secondsLeft <= 0) {
                clearInterval(countdownInterval);
                dialog.modal('hide');
                forceLogout();
            }
        }, 1000);
    }

    // var debugInterval;

    function startTimers(remaining) {
        clearTimeout(idleTimer);
        clearTimeout(warningTimer);
        // clearInterval(debugInterval);
        warningShown = false;

        // console.log('[Session] Timer set: %ds remaining (%d:%02d min)',
        //     Math.round(remaining / 1000),
        //     Math.floor(remaining / 60000),
        //     Math.floor((remaining % 60000) / 1000));

        // debugInterval = setInterval(function () {
        //     var deadline = getLastActivity() + INACTIVITY_TIMEOUT;
        //     var ms = deadline - Date.now();
        //     if (ms > 0 && !warningShown) {
        //         console.log('[Session] %ds until logout', Math.round(ms / 1000));
        //     }
        // }, 5000);

        if (remaining <= WARNING_BEFORE) {
            showWarning();
        } else {
            warningTimer = setTimeout(showWarning, remaining - WARNING_BEFORE);
        }
        idleTimer = setTimeout(forceLogout, remaining);
    }

    function onActivity() {
        setLastActivity();
        if (!warningShown) {
            startTimers(INACTIVITY_TIMEOUT);
        }
    }

    var lastActivity = getLastActivity();
    if (lastActivity > 0) {
        var elapsed = Date.now() - lastActivity;
        if (elapsed >= INACTIVITY_TIMEOUT) {
            forceLogout();
            return;
        }
        startTimers(INACTIVITY_TIMEOUT - elapsed);
    } else {
        setLastActivity();
        startTimers(INACTIVITY_TIMEOUT);
    }

    var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'wheel'];
    activityEvents.forEach(function (event) {
        document.addEventListener(event, onActivity, { passive: true });
    });

    window.addEventListener('storage', function (e) {
        if (e.key === LAST_ACTIVITY_KEY && !warningShown) {
            var elapsed = Date.now() - parseInt(e.newValue || '0', 10);
            if (elapsed < INACTIVITY_TIMEOUT) {
                startTimers(INACTIVITY_TIMEOUT - elapsed);
            }
        }
    });
})();
